import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';


function CancellationPolicy() {
  return (
    <div >

      <Header />
    

      <div className='container main-contant terms-content'>
        <div className='inner-page-container'>
          <h1 className='page-title'>Cancellation Policy</h1>
          <div className='row'>


            <div className='col-md-12'>
              <p>Welcome to Aadikaash International. These Cancellation Policies (“Policies”) govern your use of our website https://aadikaash.com and participation in any of our exhibitions or related services.</p>
              <p>By accessing or using this website and/or registering for an event organized by Aadikaash International, you agree to comply with and be bound by these Policies. If you do not agree, please do not use the website or our services.</p>
             
              <h2>Cancellation Eligibility:</h2>
              <ul>
                <li>If the event is cancelled or rescheduled by the organizer amount will be credited within 15 days (Subjected to approval by the ISJS Team)</li>              
              </ul>
              <p>Non-Cancellable Conditions:</p>
              <ul>
                <li>Cancellations will not be issued for any no-shows, partial attendance, or last-minute cancellations</li>
                <li>Entry passes once issued are non-transferable and non-cancellable unless otherwise stated.</li>
              </ul>
            


         

            </div>


          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default CancellationPolicy;
